import { FC, ReactNode } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'

type CreateObjectFieldCardPadding = 'default' | 'horizontal'

interface CreateObjectFieldCardProps {
  title: string
  description?: string
  children: ReactNode
  className?: string
  padding?: CreateObjectFieldCardPadding
}

const paddingClassByVariant: Record<CreateObjectFieldCardPadding, string> = {
  default: s.paddingDefault,
  horizontal: s.paddingHorizontal,
}

export const CreateObjectFieldCard: FC<CreateObjectFieldCardProps> = ({
  title,
  description,
  children,
  className,
  padding = 'default',
}) => (
  <section className={clsx(s.card, paddingClassByVariant[padding], className)}>
    <div className={s.header}>
      <h3 className={clsx(s.title, 'bold-16')}>{title}</h3>
      {description && (
        <p className={clsx(s.description, 'medium-14')}>{description}</p>
      )}
    </div>
    <div className={s.body}>{children}</div>
  </section>
)
